"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _union2 = _interopRequireDefault(require("lodash/union"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _checkboxChecked = _interopRequireDefault(require("cccisd-icons/svg/checkbox-checked2"));
var _checkboxUnchecked = _interopRequireDefault(require("cccisd-icons/svg/checkbox-unchecked2"));
var _checkboxPartial = _interopRequireDefault(require("cccisd-icons/svg/checkbox-partial2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _List = _interopRequireDefault(require("./List.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MetricsPicker = function MetricsPicker(props) {
  var options = props.options,
    field = props.field,
    form = props.form;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _field$value = field.value,
    types = _field$value.types,
    list = _field$value.list;

  // create sets just to perform better with the huge list of metrics
  var _useMemo = (0, _react.useMemo)(function () {
      var calcListSet = new Set(list);
      return {
        listSet: calcListSet,
        metricsCount: options.reduce(function (obj, option) {
          var selected = 0;
          if (types.includes(option.value)) {
            selected = option.list.length;
          } else {
            selected = option.list.reduce(function (cnt, metric) {
              return cnt + (calcListSet.has(metric.id) ? 1 : 0);
            }, 0);
          }
          obj[option.value] = {
            total: option.list.length,
            selected: selected
          };
          return obj;
        }, {})
      };
    }, [options, types, list]),
    listSet = _useMemo.listSet,
    metricsCount = _useMemo.metricsCount;
  var toggleExpanded = function toggleExpanded(id) {
    setExpanded((0, _xor2["default"])(expanded, [id]));
  };
  var toggleList = function toggleList(id) {
    var newList = (0, _xor2["default"])(list, Array.isArray(id) ? id : [id]);
    var newListSet = new Set(newList);
    var customTypes = options.filter(function (option) {
      return option.list.some(function (metric) {
        return !newListSet.has(metric.id);
      });
    }).map(function (option) {
      return option.value;
    });
    var allTypes = options.filter(function (option) {
      return option.list.length > 0 && option.list.every(function (metric) {
        return newListSet.has(metric.id);
      });
    }).map(function (option) {
      return option.value;
    });
    var nullTypes = options.filter(function (option) {
      return option.list.length > 0 && option.list.every(function (metric) {
        return !newListSet.has(metric.id);
      });
    }).map(function (option) {
      return option.value;
    });
    form.setFieldValue(field.name, _objectSpread(_objectSpread({}, field.value), {}, {
      list: newList,
      types: (0, _union2["default"])((0, _difference2["default"])(types, customTypes, nullTypes), allTypes)
    }));
  };
  var toggleTypes = function toggleTypes(id) {
    var newState = !types.includes(id);
    var typeMetrics = options.find(function (option) {
      return option.value === id;
    }).list.map(function (item) {
      return item.id;
    });
    var newList = newState ? (0, _union2["default"])(list, typeMetrics) : (0, _difference2["default"])(list, typeMetrics);
    form.setFieldValue(field.name, _objectSpread(_objectSpread({}, field.value), {}, {
      types: (0, _xor2["default"])(types, [id]),
      list: newList
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, options.map(function (option) {
    var isCustom = metricsCount[option.value].selected > 0 && metricsCount[option.value].selected < metricsCount[option.value].total;
    var count = /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].count
    }, "(", metricsCount[option.value].selected, "/", metricsCount[option.value].total, ")");
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: option.value,
      className: _style["default"].groupWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].group
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].check,
      onClick: function onClick() {
        return toggleTypes(option.value);
      }
    }, function () {
      if (types.includes(option.value)) {
        return /*#__PURE__*/_react["default"].createElement(_checkboxChecked["default"], null);
      }
      if (isCustom) {
        return /*#__PURE__*/_react["default"].createElement(_checkboxPartial["default"], null);
      }
      return /*#__PURE__*/_react["default"].createElement(_checkboxUnchecked["default"], null);
    }()), /*#__PURE__*/_react["default"].createElement("label", {
      onClick: function onClick() {
        return toggleExpanded(option.value);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].expandIcon
    }, expanded.includes(option.value) ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null)), option.label), option.tooltip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: option.tooltip
    }, /*#__PURE__*/_react["default"].createElement(_question["default"], {
      spaceLeft: true
    })), count), expanded.includes(option.value) && /*#__PURE__*/_react["default"].createElement(_List["default"], {
      list: option.list,
      selected: listSet,
      toggle: toggleList
    }));
  }));
};
MetricsPicker.propTypes = {
  field: _propTypes["default"].object,
  form: _propTypes["default"].object,
  options: _propTypes["default"].array
};
var _default = MetricsPicker;
exports["default"] = _default;